import React, { useState, useEffect, createContext } from "react";
const Dialog = require("react-a11y-dialog");

export const CloseDialogContext = createContext({});
export const DialogComponent = (props: any) => {
    const [dialog] = useState({ show() { }, hide() { } });

    const closeDialog = (dialogId: string): any => {
        if (document.getElementById("dialog-root")) {
            if (props.datalayerEvent) {
                window.addToDataLayer({ event: "" + props.datalayerEvent });
            }
            document.getElementById(dialogId)!.style.display = "none";
        }

        props.closeDialog(false);
    };

    const openDialog = () => {
        document.body.classList.add("no_scroll_model");
        document.getElementById(props.dialogId) && document.getElementById(props.dialogId)!.setAttribute("data-a11y-dialog-native", "true");
        document.getElementById(props.dialogId) && document.getElementById(props.dialogId)!.scrollIntoView();
        document.getElementById("dialog-root") && (document.getElementById("dialog-root")!.style.display = "block");
        document.querySelector<any>("#" + props.dialogId)!.children[0]!.style.display = "block";
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("dialog-content");
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.setAttribute("open", "true");
        document
            .querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!
            .children[0]!.children[0]!.addEventListener("click", () => closeDialog(props.dialogId));
        document.querySelector("#" + props.dialogId)!.children[0]!.setAttribute("class", "dialog-overlay");
        document.querySelector<any>("[aria-label='Close this dialog window']")!.setAttribute("data-a11y-dialog-hide", "true");
        if (props.hideCloseButton != null && props.hideCloseButton === true) {
            let dialogCloseBtns = document.querySelectorAll<any>("[aria-label='Close this dialog window']");

            dialogCloseBtns[dialogCloseBtns.length - 1].focus();
            dialogCloseBtns[dialogCloseBtns.length - 1]!.style.opacity = 0;
            dialogCloseBtns[dialogCloseBtns.length - 1]!.style.cursor = "none";
            dialogCloseBtns[dialogCloseBtns.length - 1]!.style.display = "none";
        } 
    };

    useEffect(() => {
        if (document.activeElement) {
            sessionStorage.setItem('lastActiveElement', document.activeElement.id);
        }
        dialog.show();
        const dialogElement = document.getElementById('root-dialog');
        if (dialogElement) {
            dialogElement.focus();
        }
        setTimeout(function () {
            openDialog();
        }, 500);
        const close = (e: any) => {
            if (e.keyCode === 27 && !props.noEsc) {
                props.closeDialog();
            }
        };
        window.addEventListener("keydown", close);
        return () => {
            window.removeEventListener("keydown", close);
            if (document.getElementById("dialog-root")!.childElementCount <= 1) document.body.classList.remove("no_scroll_model");
        };
    }, []);

    useEffect(() => {
        return () => {
            let lastActiveElement = sessionStorage.getItem('lastActiveElement');
            if (lastActiveElement) {
                let lastElement = document.getElementById(lastActiveElement)
                if (lastElement) {
                    lastElement.focus();
                }
            }
        }
    },[])

    return (
        <React.Fragment>
            <div id="root-dialog" tabIndex={-1}>
                <div id={"dialog-root"} style={{ display: "none" }}></div>
                <CloseDialogContext.Provider value={closeDialog}>
                    <Dialog id={props.dialogId} appRoot="#root" dialogRoot={"#dialog-root"} dialogRef={(dialog: any) => dialog} title={props.title}>
                        {props.children}
                    </Dialog>
                </CloseDialogContext.Provider>
            </div>
        </React.Fragment>
    );
};
